export default __webpack_public_path__ + "static/media/tecgeplog.26aa88a1.png";